import { dataServer } from "./axios.config";
import axios from "axios";


export const getReportsServices = () => {
    return new Promise((resolve, reject) => {
      dataServer
      .get(`app/ReportLayout/GetAllReportsForDisplay`)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  };

  export const getLoadEditDataHeaderServices = (id) => {
    return new Promise((resolve, reject) => {
      dataServer
      .get(`/app/ReportLayout/LoadEditDataHeader?ReportId=${id}`)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  };

  export const getLoadEditDataFooterServices = (id) => {
    return new Promise((resolve, reject) => {
      dataServer
      .get(`app/ReportLayout/LoadEditDataFooter?ReportId=${id}`)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  };

  export const getLoadEditDataSignaturePageServices = (id) => {
    return new Promise((resolve, reject) => {
      dataServer
      .get(`app/ReportLayout/LoadEditDataSignaturePage?ReportId=${id}`)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  };

   export const GetProcedureHeadersPageServices = (ProcName) => {
    return new Promise((resolve, reject) => {
      dataServer
      .get(`app/ReportLayout/GetProcedureHeaders?ProcName=${ProcName}`)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  };

  
  export const GetCountriesServices = () => {
    return new Promise((resolve, reject) => {
      dataServer
      .get(`app/CountryDragDrop/GetCountryList`)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  };

  export const GetDrugTypeListServices = () => {
    return new Promise((resolve, reject) => {
      dataServer
      .get(`app/DrugTypes/GetDrugTypeList`)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  };

  export const GetReportFieldValueServices = (ProcName) => {
    return new Promise((resolve, reject) => {
      dataServer
      .get(`app/ReportLayout/GetReportByProcName?ProcName=${ProcName}`)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  };


  export const SaveReportsLayout = (data) => {
    return new Promise((resolve, reject) => {
        dataServer
        .post(`app/ReportLayout/SaveLayout`, data)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  };

  export const SaveReportService = (data) => {
    return new Promise((resolve, reject) => {
        dataServer
        .post(`app/ReportLayout/SaveReport?ReportId=${data.reportId}`, data)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  };

  export const UpdateReportService = (id, data) => {
    return new Promise((resolve, reject) => {
        dataServer
        .put(`app/ReportLayout/UpdateReport?Id=${id}`, data)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  };
  
  

  export const getAllProceduresForDisplay = () => {
    return new Promise((resolve, reject) => {
      let url = `app/ReportLayout/GetAllProceduresForDisplay`;
    
      dataServer
        .get(url)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  };
  
  

  export const GetSelectedProcedures = () => {
    return new Promise((resolve, reject) => {
      dataServer
      .get(`app/ReportLayout/GetSelectedProcedures`)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  };


  export const assignProcedureToReportServices = (data) => {
    return new Promise((resolve, reject) => {
      dataServer
        .post(`/app/ReportLayout/AssignProcedureToReport`, data)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  };

  export const saveTranslationsServices = (data) => {
    return new Promise((resolve, reject) => {
      dataServer
        .post(`/app/ReportLayout/SaveTranslations`, data)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  };

  export const getReportLayoutById = (id) => {
    return new Promise((resolve, reject) => {
      dataServer
      .get(`app/ReportLayout/GetReportLayoutById?Id=${id}`)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  };


  export const UpdateSelectedReportService = (data) => {
    const { id, ...restData } = data;
  
    return new Promise((resolve, reject) => {
      dataServer
        .post(`/app/ReportLayout/UpdateReportLayout?Id=${id}`, restData)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  };


  export const getTranslationDataServices = (name) => {
    return new Promise((resolve, reject) => {
      dataServer
        .get(`/app/ReportLayout/GetTranslationData?HeaderName=${name}`)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  };